/**
 * 목표 관리 데모 페이지 (Mock 버전)
 */

import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

const mockGoals = [
  { id: '1', student_name: '김민수', goal: '수학 90점 이상', progress: 75, deadline: '2025-11-15' },
  { id: '2', student_name: '이영희', goal: '영어 듣기 만점', progress: 60, deadline: '2025-11-30' },
  { id: '3', student_name: '박지훈', goal: '국어 독해 향상', progress: 85, deadline: '2025-11-10' },
];

const DemoGoalManagementPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.</p>
      </div>
      <DemoNavigation currentTitle="목표 관리 (데모)" currentIcon={ShieldCheckIcon} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h2 className="text-2xl font-bold">학생 목표 관리</h2>
          </div>
          <div className="p-6 space-y-6">
            {mockGoals.map((goal) => (
              <div key={goal.id} className="border rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <h3 className="font-semibold text-lg">{goal.student_name}</h3>
                    <p className="text-gray-600">{goal.goal}</p>
                  </div>
                  <span className="text-sm text-gray-500">마감: {goal.deadline}</span>
                </div>
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm text-gray-600">진행률</span>
                    <span className="text-sm font-semibold">{goal.progress}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className={`h-2 rounded-full transition-all ${
                        goal.progress >= 80 ? 'bg-green-600' : goal.progress >= 50 ? 'bg-blue-600' : 'bg-orange-600'
                      }`}
                      style={{ width: `${goal.progress}%` }}
                    />
                  </div>
                </div>
              </div>
            ))}
            <div className="mt-6 text-center text-gray-500 text-sm">
              📢 데모 모드에서는 목표 추가 및 수정이 불가능합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoGoalManagementPage;
